import request from "../utils/request";

export const list = (data) => request.get("/api/request", data);
export const update = (id, data) => request.put(`/api/request/${id}`, data);
